            
let billtype = [ ];
billtype.push( { text : "Designation Code (5 digits) + Motivation Code(5 digits) ", val:  "01" , default: true });
billtype.push( { text : "iVision Partner ID (7 digits)+ Designation Code(5 digits)+ Motivation Code(5 digits)", val:  "02" });
billtype.push( { text : "iVision Event Participant ID (10 digits)", val:  "03" });
billtype.push( { text : "iVision Pledge ID (10 digits) ", val:  "04"  });
billtype.push( { text : "Event Online Registration Code (10 digits) ", val:  "05" });
billtype.push( { text : "Online Invoice Number/Online Reference Number (14 digits)  ", val:  "06" });
billtype.push( { text : "iVision Donation Notice Number (17 digits)  ", val:  "07" });
billtype.push( { text : "The Other Usages (TBC) (17 digits)  ", val:  "08" });

let currency  = [
 {val:"344" , text: 'HKD'  , default: true}
,{val:"156" , text: 'CNY' }
];

let  resource = {
    billtype: billtype
,   currency: currency
} ;


// let excelHeader = [
//     "Bill Type
// 01= Designation Code (5 digits) + Motivation Code(5 digits)
// 02=Partner ID (7 digits)+ Designation Code(5 digits)+ Motivation Code(5 digits)
// 03=Event Participant ID (10 digits)
// 04=Pledge ID (10 digits) 
// 05=Event Online Registration Code (10 digits)
// 06=Online Invoice Number/Online Reference Number (14 digits)
// 07=Donation Notice Number (17 digits) 
// 08=The Other Usages (TBC) (17 digits) "	
// "Transaction Amount 
// If input Amount =0 or blank, the donor will input later"	

// Partner ID/Event Participant ID/Pledge ID/Event Online Registration Code/Online Invoice Number/Online Reference Number/Donation Notice Number/Others	Designation Code	Motivation Code	Error Message	Bill Reference Number	FPS QR Code Value	File Name


// ]
export default   resource